/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/frontend and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

/********************************************************************
 *
 * Stylesheets
 *
 *******************************************************************/

import 'src/scss/application';


/********************************************************************
 *
 * Images
 *
 *******************************************************************/

 require.context('images', true);



/********************************************************************
 *
 * External JS dependencies
 *
 *******************************************************************/

require("trix")
require("@rails/actioncable")
require("@rails/actiontext")
require("@rails/ujs").start()

import "chartkick/chart.js"

import 'bootstrap';

import "@fortawesome/fontawesome-free/js/all";

import Turbolinks from 'turbolinks';
Turbolinks.start();

// Note that initial attempts to import the signature_pad library here
// with the other imports was not working as easily as we'd expect,
// so the import is currently at the top of our signature_pad.js file.



/********************************************************************
 *
 * Application JS
 *
 *******************************************************************/

import 'src/js/comment_alert';
import 'src/js/confirmation_quick_save';
import 'src/js/dropdown_submit';
import 'src/js/dynamic_nested';
import 'src/js/manual_ratio_override_comment';
import 'src/js/pr_review_comment';
import 'src/js/provider_email';
import 'src/js/reports';
import 'src/js/scripting';
import 'src/js/seconds_counter';
import 'src/js/setup_flatpickr';
import 'src/js/signature_pad';
import 'src/js/sticky_submit';
import 'src/js/teaching_tool_auto_select';
import 'src/js/time_entry';
import 'src/js/toggle_answer_options';
import 'src/js/tooltip';
import 'src/js/total_points_counter';
import 'src/js/unavailable_for_review';



/********************************************************************
 *
 * ActionCable JS
 *
 *******************************************************************/

 import 'src/js/channels/consumer.js';
 import 'src/js/channels/sync_progress_channel.js';
